import React from 'react'
import PropTypes from 'prop-types'

import { Link } from '@aok/ui-elements'
import { Mail } from '@aok/icon-functional'

const OfferSearchEmail = ({ email, className }) => {
  let mails = [email]

  if (email.match(',')) {
    mails = email.split(',')
  }

  return (
    <div className={className}>
      {mails.map((address, index) => (
        <div key={index} className="flex gap-x-8 items-start justify-start">
          <Mail className="w-16 h-16 text-586167 fill-current shrink-0 mt-3" />
          <Link className={className} href={`mailto:${address}`} title={address} variant="structure" />
        </div>
      ))}
    </div>
  )
}

OfferSearchEmail.propTypes = {
  email: PropTypes.string,
  className: PropTypes.string,
}

OfferSearchEmail.defaultProps = {
  className: '',
}

export default OfferSearchEmail
